// extracted by mini-css-extract-plugin
export default {"blogContainer":"Blog_blogContainer__ApXHM","blogPost":"Blog_blogPost__V3Ymk"};